<template>
    <div class="bg-white text-left p-8 rounded-3xl justify-between flex flex-col gap-3">
        <div class="space-y-3">
            <div class="flex flex-row gap-3 items-start">
                <div v-if="image" class="flex-shrink-0">
                    <img :src="image" class="aspect-square w-12 object-cover rounded-full">
                </div>
                <div v-else class="flex-shrink-0">
                    <div class="aspect-square w-12 bg-gray-200 rounded-full flex items-center justify-center">
                        <span class="text-gray-500 font-bold text-xl">{{ identity.charAt(0) }}</span>
                    </div>
                </div>
                <div class="flex-1">
                    <p class="font-bold">{{ identity }}</p>
                    <p v-if="badge" class="text-xs text-gray-600">{{ badge }}</p>
                </div>
            </div>
            <ul>
                <li class="text-amber-400">
                    <fa v-for="i in 5" :key="i" :icon="i <= note ? ['fa', 'star'] : ['far', 'star']"></fa>
                </li>
            </ul>
            <p class="text-xs text-gray-600">{{ date }}</p>
            <p>{{ description }}</p>
            <p v-if="visitedDate" class="text-xs text-gray-500 italic mt-2">{{ visitedDate }}</p>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        description: {
            type: String,
            required: true
        },
        image: {
            type: String,
            required: false,
            default: null
        },
        identity: {
            type: String,
            required: true
        },
        date: {
            type: String,
            required: true
        },
        note: {
            type: Number,
            required: true
        },
        badge: {
            type: String,
            required: false,
            default: null
        },
        visitedDate: {
            type: String,
            required: false,
            default: null
        }
    }
}
</script>
